import { IconStyled, IconStylesProps } from './IconStyles';

export const CalendarArrowRight = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
  transform,
  onClick,
}: Partial<IconStylesProps>) => (
  <IconStyled
    onClick={onClick}
    size={size}
    className={className}
    viewBox='0 0 14 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      style={{
        transform,
        transformOrigin: '50% 50%',
      }}
      d='M9.68 8.598a.828.828 0 0 0 0-1.16L2.86.582c-.352-.316-.88-.316-1.196 0l-.809.809c-.316.316-.316.843 0 1.195L6.27 8 .855 13.45c-.316.35-.316.878 0 1.195l.81.808c.315.317.843.317 1.194 0l6.82-6.855Z'
      fill={fill}
    />
  </IconStyled>
);
